import { createFirebaseFunctionsCallableClient } from '@shveitsar/callable-frontend/firebase';
import { SERVICE_STUFF } from '@shveitsar/stuff-types';
import { firebaseApp } from './firebase';
export const stuffApi = createFirebaseFunctionsCallableClient({
    functionName: `${SERVICE_STUFF}-api`,
    firebase: firebaseApp,
    emulator: process.env.VUE_APP_EMULATOR_FUNCTIONS
        ? (() => {
            const [host, port] = process.env.VUE_APP_EMULATOR_FUNCTIONS.split(':');
            return { host, port: +port };
        })()
        : undefined
});
